import React from "react";
import PortfolioList from "../components/PortfolioList";

const MyPortfolios = () => {
  return <PortfolioList />;
};

export default MyPortfolios;
